import { sendErrorNotification } from "@components/Notifications";
import { circulationStatsApi } from "@api/stats/circulationStats";

export const IS_LOADING = "statsPickBorrowing/IS_LOADING";
export const SUCCESS = "statsPickBorrowing/SUCCESS";
export const HAS_ERROR = "statsPickBorrowing/HAS_ERROR";

export const fetchPickBorrowingStats = (fromDate, toDate) => {
  return async (dispatch) => {
    dispatch({ type: IS_LOADING });

    try {
      const response = await circulationStatsApi.getPickBorrowingStats(
        fromDate,
        toDate
      );

      dispatch({
        type: SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({ type: HAS_ERROR, payload: error });
      dispatch(sendErrorNotification(error));
    }
  };
};
